// The interface languages. `pt` is Brazilian Portuguese (decided 2026-09-30):
// AWS Translate's `pt` target is Brazilian, and both pt-BR and pt-PT browsers
// get it. `ja` is Japanese.
export const SUPPORTED = ['en', 'es', 'pt', 'ja'] as const

export type Lang = (typeof SUPPORTED)[number]

export const DEFAULT_LANG: Lang = 'en'

// The persisted switcher choice. A frozen storage key: never translate or
// rename it, or every stored choice is silently forgotten.
export const LANGUAGE_STORAGE_KEY = 'cb_interface_language'

// Each language named in ITSELF (an endonym), the same in every interface
// language, so a reader who cannot read the current one still finds theirs.
// Deliberately not catalog keys: a translated "English" ("Inglés") would
// defeat that.
export const LANGUAGE_NAMES: Record<Lang, string> = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
  ja: '日本語',
}

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (SUPPORTED as readonly string[]).includes(value)
}
